<template>
    <div class="col-sm-12">
        <div class="row">
            <div class="col-sm-12">
                <div class='chart-row'>
                    <div id="leads-hour-of-day" class='chart-column'></div>
                    <div id="calls-hour-of-day" class='chart-column'></div>
                </div>                
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: [
            'data',
            'activeTab',
        ],
        watch: {
            data() {
                this.refresh();
            },
            activeTab() {
                if (this.activeTab == 'hour-of-day') this.refresh();
            }
        },
        methods: {
            isGoogleChartsLoaded() {
                return typeof google !== 'undefined' && google.visualization && typeof google.visualization.arrayToDataTable === 'function';
            },
            refresh() {
                if (!this.isGoogleChartsLoaded()) return;
                this.drawLeadsChart();
                this.drawCallsChart();
            },
            drawLeadsChart() {
                var data = google.visualization.arrayToDataTable(
                    _.concat(
                        [['Hour of Day', '# Leads']],
                        _.map(this.data.hourOfDay, (value, key) => [ key, parseInt(value) ])
                    )
                );
                var options = {
                    title: 'Leads',
                    colors: ['#13406d'],
                    legend: 'none'
                };

                var chart = new google.visualization.ColumnChart(document.getElementById('leads-hour-of-day'));
                chart.draw(data, options);
            },
            drawCallsChart() {
                var data = google.visualization.arrayToDataTable(
                    _.concat(
                        [['Hour of Day', '# Calls']],
                        _.map(this.data.callsHourOfDay, (value, key) => [ key, parseInt(value) ])
                    )
                );
                var options = {
                    title: 'Calls',
                    colors: ['#13406d'],
                    legend: 'none'
                };

                var chart = new google.visualization.ColumnChart(document.getElementById('calls-hour-of-day'));
                chart.draw(data, options);
            },
        },
    }
</script>

<style scoped>
    .chart-row {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        width: 100%;
    }
    .chart-column {
        display: flex;
        flex-direction: column;
        flex-basis: 100%;
        flex: 1;
        min-height: 40em;
    }    
</style>
